export default __webpack_public_path__ + "static/media/spooky_hill_background_m1.4b9472cf.jpg";